export function swapUnderscoreHyphen(input: string): string {
  return input.replace(/[_-]/g, (char) => (char === "_" ? "-" : "_"));
}
